var exports = {
  "uu": "VoiceLobbyShared.module__actionButtons___QlpSOE",
  "hP": "VoiceLobbyShared.module__actionButton___QlpSOE",
  "zc": "VoiceLobbyShared.module__iconContainer___QlpSOE",
  "KA": "VoiceLobbyShared.module__iconContainerBrand___QlpSOE",
  "cF": "VoiceLobbyShared.module__iconContainerDanger___QlpSOE",
  "hO": "VoiceLobbyShared.module__iconContainerTertiary___QlpSOE",
  "cY": "VoiceLobbyShared.module__iconContainerSuccess___QlpSOE",
  "gE": "VoiceLobbyShared.module__actionIcon___QlpSOE",
  "uI": "VoiceLobbyShared.module__actionIconSecondary___QlpSOE",
  "K2": "VoiceLobbyShared.module__actionText___QlpSOE",
  "Hd": "VoiceLobbyShared.module__connectionInfo___QlpSOE",
  "Il": "VoiceLobbyShared.module__connectionHeader___QlpSOE",
  "p1": "VoiceLobbyShared.module__connectionStatusInfo___QlpSOE",
  "bn": "VoiceLobbyShared.module__connectionTitle___QlpSOE",
  "fV": "VoiceLobbyShared.module__connectionSubtitle___QlpSOE",
  "Cb": "VoiceLobbyShared.module__connectionStatusDot___QlpSOE",
  "wL": "VoiceLobbyShared.module__statsGrid___QlpSOE",
  "N8": "VoiceLobbyShared.module__statRow___QlpSOE",
  "Zh": "VoiceLobbyShared.module__statLabel___QlpSOE",
  "cR": "VoiceLobbyShared.module__statValue___QlpSOE",
  "_x": "VoiceLobbyShared.module__statValuePrimary___QlpSOE",
  "V4": "VoiceLobbyShared.module__endpointValue___QlpSOE",
  "TR": "VoiceLobbyShared.module__connectionIdValue___QlpSOE",
  "JX": "VoiceLobbyShared.module__maxWidth___QlpSOE",
};

module.exports = exports;
